import React, { FC } from 'react';

// components
import MessagesSummaryCard from './MessagesSummaryCard';

interface CardProps {
    heading: string;
    description: string;
    handleViewMore: () => void;
    dataLength?: number;
}

const MessageCard: FC<React.PropsWithChildren<CardProps>> = ({
    heading,
    description,
    handleViewMore,
    dataLength,
}) => {
    return (
        <MessagesSummaryCard
            heading={heading}
            description={description}
            handleViewMore={() => handleViewMore()}
        >
            {dataLength}
        </MessagesSummaryCard>
    );
};
export default MessageCard;
